<template>
  <div class="row">
    <div class="col-xs-12 col-md-8">
      <div class="row island">
        <div class="col-xs-12 col-md-6">
          <div class="entry-selectors">
            <div class="island">
              <season-selector v-if="isManager" />
              <user-selector v-if="userSelectorVisible" />
              <template v-if="selectorsRenderable">
                <chapter-selector />
                <category-selector />
              </template>
              <p v-else>
                {{
                  lang.get(
                    'entries.form.errors.problem-rendering-configuration'
                  )
                }}
              </p>
            </div>
            <entry-title />
          </div>
        </div>
        <div class="col-xs-12 col-md-6">
          <category-description />
        </div>
      </div>
      <draggable-fields
        v-if="configurationMode"
        :fields="fields"
        :visible-fields="visibleFields"
        resource-name="Entries"
        :tab="tab"
      />
      <fields
        v-else
        :fields="visibleFields"
        resource-name="Entries"
        :tab="tab"
        :transition="transition"
      />
    </div>
    <div v-if="sponsorsEnabled" class="col-xs-12 col-md-4">
      <div class="sponsors">
        <sponsors from="chapter" />
        <sponsors from="category" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import EntryTitle from '../EntryTitle';
import Fields from '../Fields/Fields';
import ChapterSelector from '../Selectors/ChapterSelector';
import CategorySelector from '../Selectors/CategorySelector';
import SeasonSelector from '../Selectors/SeasonSelector';
import UserSelector from '../Selectors/UserSelector';
import Sponsors from '../Sponsors';
import CategoryDescription from '../CategoryDescription';
import DraggableFields from '../Configuration/DraggableFields';

export default {
  inject: ['lang'],
  components: {
    EntryTitle,
    Fields,
    ChapterSelector,
    CategorySelector,
    SeasonSelector,
    UserSelector,
    Sponsors,
    CategoryDescription,
    DraggableFields
  },
  props: {
    tab: {
      type: Object,
      required: true
    },
    transition: {
      type: String,
      default: 'push'
    }
  },
  computed: {
    ...mapState('entryForm', ['isManager', 'sponsorsEnabled']),
    ...mapState('entryFormConfiguration', [
      'configurationMode',
      'configuredCategory'
    ]),
    ...mapGetters('entryForm', [
      'entryFields',
      'visibleEntryFields',
      'userSelectorVisible',
      'selectedChapter',
      'selectedCategory'
    ]),
    fields() {
      return this.entryFields(this.tab.id);
    },
    visibleFields() {
      return this.visibleEntryFields(this.tab.id);
    },
    selectorsRenderable() {
      if (
        this.configuredCategory &&
        this.selectedCategory &&
        this.selectedChapter &&
        !this.selectedCategory.chapterSlugs.includes(this.selectedChapter.slug)
      ) {
        return false;
      }
      return true;
    }
  }
};
</script>
